<template>
  <div>
    <!-- <b-card>
    <div slot="header">User Profile</div>-->
    <b-form>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Employee ID</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                id="EmployeeID"
                placeholder="Employee ID"
                required
                type="text"
                autocomplete="EmployeeID"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Department</b-input-group-text>
              </b-input-group-prepend>
              <b-select class="dropdown">
                <option v-for="dept in department.departments" :key="dept">{{ dept }}</option>
              </b-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <CoolSelect
              class="form-input dropdown-content"
              placeholder="Department"
              theme="bootstrap"
              :items="department.departments"
              tooltip="Departments"
            >
              <template slot="input-before">
                <b-input-group-prepend>
                  <b-input-group-text>Department</b-input-group-text>
                </b-input-group-prepend>
              </template>
              <!-- <template slot="item" slot-scope="{ item }">
              <div class="item">-->
              <!-- <img :src="item.thumbnail" class="logo" /> -->

              <!-- <span class="item-name" style="font-size:8px;">{{ item }}</span>
                </div>
              </template>-->
            </CoolSelect>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Department</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input list="input-list" id="input-with-list" class="dropdown custom-select"></b-form-input>
              <b-form-datalist id="input-list" :options="department.departments"></b-form-datalist>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>-->
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Wage/Salary</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                id="Earning"
                placeholder="Wage/Salary"
                required
                type="text"
                v-mask="'(###) ###-####'"
                autocomplete="Earning"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Type</b-input-group-text>
              </b-input-group-prepend>
              <b-select class="dropdown">
                <option>Hourly</option>
                <option>Salary</option>
              </b-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Employee Tax Rate</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="TaxRate" placeholder="Tax Rate" required type="text"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Cost of Benefits</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="Benefits" placeholder="Benefits" required></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Date of Birth</b-input-group-text>
              </b-input-group-prepend>
              <datepicker :config="options" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Sex</b-input-group-text>
              </b-input-group-prepend>
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group
                  class="mr-3"
                  id="radiosBtn"
                  buttons
                  button-variant="outline-secondary"
                  v-model="selected"
                  name="radiosBtn"
                >
                  <b-form-radio class="mx-0" value="Male">Male</b-form-radio>
                  <b-form-radio class="mx-0" value="Female">Female</b-form-radio>
                  <b-form-radio class="mx-0" value="Neutral">Neutral</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
//import Datepicker from "vuejs-datepicker";
//import "bootstrap/dist/css/bootstrap.css";

// Import this component
import datepicker from "vue-bootstrap-datetimepicker";
//import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
//import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { CoolSelect } from "vue-cool-select";

export default {
  name: "EmployeeCard",
  computed: {
    ...mapState(["department"]),
    ...mapGetters("department", ["getDepartments"])
  },
  components: {
    datepicker,
    CoolSelect
  },
  data() {
    return {
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false
      }
    };
  }
};
</script>


</style>